import { render } from "./SignInIDCard.vue?vue&type=template&id=14a270ce"
import script from "./SignInIDCard.vue?vue&type=script&lang=ts"
export * from "./SignInIDCard.vue?vue&type=script&lang=ts"
script.render = render

export default script